"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONE_TO_ONE = exports.LAWFUL_BASIS_PQL = exports.GDPR_COMPLIANCE_ENABLED = exports.IMPLICIT_PROCESSING_CONSENT_TYPE = exports.FORMS_KEYS = exports.CHECKBOX_KEYS = exports.KEYS = void 0;
var KEYS = {
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  LEGITIMATE_INTEREST_TEXT: 'legitimateInterestPrivacyPolicyText',
  LEGITIMATE_INTEREST_SUBSCRIPTIONS: 'legitimateInterestSubscriptionTypes',
  LEGITIMATE_INTEREST_LAWFUL_BASIS: 'legitimateInterestLegalBasis',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  IMPLICIT_PROCESSING_CONSENT_TEXT: 'implicitProcessingConsentText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText'
};
exports.KEYS = KEYS;
var CHECKBOX_KEYS = {
  COMMUNICATION_TYPE_ID: 'communicationTypeId',
  LABEL: 'label'
};
exports.CHECKBOX_KEYS = CHECKBOX_KEYS;
var FORMS_KEYS = {
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText'
};
exports.FORMS_KEYS = FORMS_KEYS;
var IMPLICIT_PROCESSING_CONSENT_TYPE = 'IMPLICIT';
exports.IMPLICIT_PROCESSING_CONSENT_TYPE = IMPLICIT_PROCESSING_CONSENT_TYPE;
var GDPR_COMPLIANCE_ENABLED = 'GDPRComplianceEnabled';
exports.GDPR_COMPLIANCE_ENABLED = GDPR_COMPLIANCE_ENABLED;
var LAWFUL_BASIS_PQL = 'LEGITIMATE_INTEREST_PQL';
exports.LAWFUL_BASIS_PQL = LAWFUL_BASIS_PQL;
var ONE_TO_ONE = 'ONE_TO_ONE';
exports.ONE_TO_ONE = ONE_TO_ONE;